import { FormikValues } from "formik"

import { snakeCase } from "../change-case"
import { SEND_DEMO_URL } from "../urls"
import { TremendousApiResponse } from "./types"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchPost = <Res>(path: string, body?: any): Promise<Res> =>
  fetch(path, {
    method: `POST`,
    headers: {
      "content-type": "application/json",
    },
    body: body ? JSON.stringify(body) : undefined,
  }).then(res => res.json())

export const sendDemo = (email: string) =>
  fetchPost<TremendousApiResponse>(SEND_DEMO_URL, { email })

export const recipientTourRequest = (data: FormikValues) => {
  const formattedBody = Object.fromEntries(
    Object.entries(data).map(([key, value]) => [snakeCase(key), value.trim()]),
  )
  return fetchPost<TremendousApiResponse>(SEND_DEMO_URL, formattedBody)
}
